import { createApp } from 'vue'
import App from './App.vue'
import "@/assets/css/style.css";


const app = createApp(App);
app.use()
app.mount('#app');
